import { readonly, ref } from 'vue'
import { CurrentUserType } from '@/shared/types'

const user = ref<CurrentUserType>()
const isAuth = ref(false)

export const useUser = (): any => {
  const setUser = (userData: CurrentUserType) => {
    user.value = userData
  }

  const setIsAuth = (auth: boolean) => {
    isAuth.value = auth
  }

  return {
    user: readonly(user),
    isAuth: readonly(isAuth),
    setUser,
    setIsAuth,
  }
}

const isUserListingUpdated = ref(false)
const dateUserListing = ref({})

export const useUserListing = (): any => {
  const setUpdateUserListing = (isUpdated: boolean) => {
    isUserListingUpdated.value = isUpdated
  }
  const setUpdateDateUserListing = (filter: object) => {
    dateUserListing.value = filter
  }

  return {
    isUserListingUpdated: readonly(isUserListingUpdated),
    dateUserListing,
    setUpdateUserListing,
    setUpdateDateUserListing,
  }
}
